import { HttpRequest } from '@angular/common/http';
import { environment } from '@env/environment';

const apiRoots = [environment.apiRoot, environment.employeeHubApiRoot, environment.reportingApiRoot, environment.hrUrl];

function isApiRoot(url: string): boolean {
  return apiRoots.some((apiRoot) => url.includes(apiRoot));
}

/**
 * Determines if a request should be intercepted for JWT token addition
 * @param request The HTTP request to check
 * @returns true if the request should be intercepted, false otherwise
 */
export function isCloudApiUrl(request: HttpRequest<any>): boolean {
  return isApiRoot(request.url);
}
